import React, { useState } from 'react';
import { LogoMarca } from '../components/MarcaCurriculo';
import { useNavigate } from 'react-router-dom';

export default function WelcomeScreen() {
  const navigate = useNavigate();
  const [showExample, setShowExample] = useState(false);
  
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '70vh' }}>
      <LogoMarca style={{ width: 180, marginBottom: 12 }} />
      <h1 style={{ textAlign: 'center', color: 'var(--primary-color)', fontWeight: 800, fontSize: 32, marginBottom: 8 }}>Bem-vindo ao Currículo Popular</h1>
      <p style={{ textAlign: 'center', fontSize: 18, color: 'var(--text-color)', maxWidth: 480, marginBottom: 40, lineHeight: 1.5 }}>
        Crie, edite e salve seu currículo de forma simples e rápida. Gere um PDF pronto para envio e compartilhe sua experiência profissional com facilidade.
      </p>
      
      <div style={{ display: 'flex', gap: 24, justifyContent: 'center', marginTop: 32, flexWrap: 'wrap' }}>
        <button
          className="btn btn-primary"
          style={{ fontSize: 17, padding: '8px 16px', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '12px' }}
          onClick={() => {
            sessionStorage.removeItem('cpf');
            sessionStorage.removeItem('curriculoData');
            sessionStorage.setItem('anon', '1');
            navigate('/curriculo');
          }}
        >
          <img src="/assets/logos-07.svg" alt="Ícone de Currículo" style={{ width: '60px', height: '60px', filter: 'brightness(0) invert(1)' }} />
          Criar meu Currículo do Zero
        </button>
      </div>

      <button
        onClick={() => setShowExample(true)}
        style={{
          marginTop: '24px',
          padding: '12px 24px',
          backgroundColor: 'transparent',
          border: '2px solid var(--primary-color)',
          borderRadius: '8px',
          color: 'var(--primary-color)',
          fontSize: '16px',
          fontWeight: 600,
          cursor: 'pointer',
          transition: 'all 0.2s ease'
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.backgroundColor = 'var(--primary-color)';
          e.currentTarget.style.color = 'white';
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.backgroundColor = 'transparent';
          e.currentTarget.style.color = 'var(--primary-color)';
        }}
      >
        Veja um Exemplo
      </button>

      {showExample && (
        <div
          onClick={() => setShowExample(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            padding: '20px',
            cursor: 'pointer'
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: 'relative',
              maxWidth: '90vw',
              maxHeight: '90vh',
              backgroundColor: 'white',
              borderRadius: '8px',
              overflow: 'hidden',
              boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
            }}
          >
            <button
              onClick={() => setShowExample(false)}
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                width: '36px',
                height: '36px',
                borderRadius: '50%',
                backgroundColor: 'var(--primary-color)',
                color: 'white',
                border: 'none',
                fontSize: '20px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 10
              }}
            >
              ×
            </button>
            <img
              src="/assets/exemplo-curriculo.png"
              alt="Exemplo de Currículo"
              style={{
                maxWidth: '100%',
                maxHeight: '85vh',
                objectFit: 'contain'
              }}
            />
          </div>
        </div>
      )}

      <div style={{ marginTop: '60px', padding: '32px', backgroundColor: 'var(--light-gray)', borderRadius: '12px', maxWidth: '800px', width: '100%' }}>
        <h2 style={{ textAlign: 'center', color: 'var(--primary-color)' }}>Por que usar o Currículo Popular?</h2>
        <div style={{ display: 'flex', gap: '32px', justifyContent: 'center', marginTop: '32px', flexWrap: 'wrap' }}>
          
          <div style={{ flex: '1', minWidth: '220px', textAlign: 'center' }}>
            <img src="/assets/icones-curriculo-02.svg" alt="Ícone" style={{ width: '48px', height: '48px', marginBottom: '16px' }} />
            <h3 style={{ color: 'var(--text-color)', marginBottom: '8px', fontSize: '18px' }}>Destaca Experiências</h3>
            <p style={{ color: 'var(--text-light)', fontSize: '14px', lineHeight: '1.4' }}>Mostre o que você faz de melhor de forma focada e assertiva.</p>
          </div>

          <div style={{ flex: '1', minWidth: '220px', textAlign: 'center' }}>
            <img src="/assets/icones-curriculo-03.svg" alt="Ícone" style={{ width: '48px', height: '48px', marginBottom: '16px' }} />
            <h3 style={{ color: 'var(--text-color)', marginBottom: '8px', fontSize: '18px' }}>Facilidade</h3>
            <p style={{ color: 'var(--text-light)', fontSize: '14px', lineHeight: '1.4' }}>Uma plataforma que edita para você. Direto ao ponto.</p>
          </div>

          <div style={{ flex: '1', minWidth: '220px', textAlign: 'center' }}>
            <img src="/assets/icones-curriculo-04.svg" alt="Ícone" style={{ width: '48px', height: '48px', marginBottom: '16px' }} />
            <h3 style={{ color: 'var(--text-color)', marginBottom: '8px', fontSize: '18px' }}>Modelos Vencedores</h3>
            <p style={{ color: 'var(--text-light)', fontSize: '14px', lineHeight: '1.4' }}>Utilize padrões limpos que vão direto para a mesa do selecionador.</p>
          </div>

        </div>
      </div>
    </div>
  );
}
